<div class="cmdb-qrcode-container" *ngIf="!isLoadingLabels && !isLoadingQrCode && qrValue !== ''">
	<qrcode [width]="256" [colorDark]="qrColorDark" [colorLight]="qrColorLight" [qrdata]="qrValue" [errorCorrectionLevel]="'M'"> </qrcode>

	<div class="ci-data-container" *ngIf="ciBasicData">
		<span>{{ labels.lbl_geral_tipo }}: </span>
		<span>{{ labels[ciBasicData.type] ? labels[ciBasicData.type] : ciBasicData.type }}</span>

		<span>{{ labels.lbl_geral_identificacao }}: </span>
		<span>{{ ciBasicData.identification }}</span>
	</div>

	<div class="button-container" *ngIf="isLoggedIn != undefined">
		<div class="button" *ngIf="isLoggedIn === true" (click)="openCmdb()">{{ labels.lbl_kb_mais_info }}</div>
		<div class="button" *ngIf="isLoggedIn === false" (click)="openLogin()">{{ labels.lbl_clique_logar_e_ver_mais_informacoes }}</div>
	</div>
</div>

<div class="cmdb-qrcode-container" *ngIf="!isLoadingLabels && !isLoadingQrCode && qrValue === ''">
	{{ labels.lbl_rep_custom_arquivo_nao_encontrado }}
</div>

<div class="loading-container" *ngIf="isLoadingLabels || isLoadingQrCode">
	<cpi-svg-gears></cpi-svg-gears>
	<div>{{ labels.lbl_edocs_carregando }}!</div>
</div>
